import React, { useEffect, useState, useRef, useContext } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import MainSlider from "../../Components/MainSlider/MainSlider";
import AboutUS from "../../Components/AboutUs/AboutUs";
import BestServices from "../../Components/BestServices/BestServices";
import WhyChooseUs from "../../Components/WhyChooseUs/WhyChooseUs";
import Journey from "../../Components/Journey/Journey";
import Support from "../../Components/SupportComponent/Support";
import TestimonialsSection from "../../Components/TestimonialSection/Testimonial";
import FAQSection from "../../Components/FAQSection/FAQ";
import BlogCarousel from "../../Components/BlogsSection/BlogsSection";
import Footer from "../../Components/FooterSection/FooterSection";
import LocationModal from "../../Components/LocationModal";
import audioFile from "../../assets/om_sound_new.mp3";
import Newsletter from "../../Components/NewsletterModal";
import { Helmet } from "react-helmet-async";
import { LoaderContext } from "../../AuthContext/AuthContext";
import DownloadApp from "../../Components/DownLoadApp/DownloadApp";
import CounterSection from "../../Components/DownLoadApp/CounterSection";
import WhatsAppChatbotButton from "../../WhatsAppChatBot";
import { useLocation, useNavigate } from "react-router-dom";
import LazySection from "./LazySection";
import CustomChatWidget from "../../CustomChatWidget";
import ReferAndEarn from "../../Components/ReferAndEarn/ReferAndEarn";
import LoginPopUp from "../../Components/LoginPopup";
// import audioFile from '../../public/assets/om_sound_new.mp3'

const Home = () => {
  const audioRef = useRef(null);
  const { setLoader, loader, isLocationUpdate, setIsLocationUpdate, selectedLanguageID } =
    useContext(LoaderContext);
  const [userCity, setUserCity] = useState(localStorage.getItem("userCity"));
  const [showModal, setShowModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const hasScrolled = useRef(false);
  const userHasInteracted = useRef(false); // 👈 New ref to track actual user scroll
  const selectedCity = localStorage.getItem("userCity");
  const [onGetOTP, setOnGetOTP] = useState(false);
  const [count, setCount] = useState(1);
  const location = useLocation()
  const navigate = useNavigate()
  const referralCode = localStorage.getItem("referralID");
  const userID = localStorage.getItem("userID");

  useEffect(() => {

    const audio = audioRef.current;
    if (audio) {
      audio
        .play()
        .catch((error) => console.error("Audio playback failed:", error));
    }

  }, []);

  useEffect(() => {
    if (isLocationUpdate) {
      navigate('/')
    }
  }, [isLocationUpdate])

  useEffect(() => {

    if (location?.pathname === '/Register' && (userID === null || userID === undefined || userID === '')) {
      setCount(count + 1)
      setShowLoginModal(true)
    }
  }, [location])
  useEffect(() => {
    if (onGetOTP) setShowLoginModal(false);
  }, [onGetOTP]);

  const hasShownModal = useRef(false); // Ensures modal shows only once
  const scrollStarted = useRef(false); // Tracks if user really started scrolling


  useEffect(() => {
    const handleScroll = () => {
      // Skip the first scroll event (possibly from restored position)
      if (!scrollStarted.current) {
        scrollStarted.current = true;
        return;
      }

      // Open modal only if scrollY > 600 and no city is selected
      if (!hasShownModal.current && window.scrollY > 600 && !selectedCity) {
        hasShownModal.current = true;
        setShowModal(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [selectedCity]);

  const handleSelectCity = (city) => {
    if (city) {
      setShowModal(false);
      localStorage.setItem("userCity", city);
      setUserCity(city);
      setIsLocationUpdate(true);

    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Myomnamo",
    alternateName: "Myomnamo Spiritual Services",
    url: "https://www.myomnamo.com/",
    logo: "https://www.myomnamo.com/assets/images/new/logo.png",
    description: "Myomnamo offers authentic online puja services including booking pandits, pujas, horoscopes, temple visits, and spiritual products.",

    contactPoint: {
      "@type": "ContactPoint",
      telephone: "8879222277",
      contactType: "customer service",
      contactOption: "TollFree",
      areaServed: "IN",
      availableLanguage: ["en", "Hindi"],
    },
    sameAs: [
      "https://www.facebook.com/omnamoapp/",
      "https://x.com/My_OmNamo",
      "https://www.instagram.com/myomnamo_official/",
      "https://www.youtube.com/@myomnamo-beliefredefined9691",
      "https://www.linkedin.com/company/my-om-namo/",
    ],
  };

  const webpageSchema = {
    "@context": "http://schema.org",
    "@type": "WebPage",
    name: "Book Complete Spiritual & Online Puja Services | Myomnamo",
    url: "https://www.myomnamo.com/",
    description:
      "Looking for authentic online puja services? Book pandits, pujas, horoscopes & temple visits online. Shop puja samagri & spiritual items from our trusted e-store.",
    publisher: {
      "@type": "Organization",
      name: "Myomnamo",
      "logo": {
        "@type": "ImageObject",
        "url": "https://www.myomnamo.com/assets/images/new/logo.png"
      }

    },
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: "Myomnamo",
    image: "https://www.myomnamo.com/assets/images/new/logo.png",
    "@id": "",
    url: "https://www.myomnamo.com/",
    description: "Authentic online puja services offering pandit booking, pujas, horoscopes, temple visits, and spiritual products.",
    "priceRange": "₹₹",
    telephone: "+91 8879222277",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "BiG Strategic Advisors Group A 321, Lodha Supremus II, Beside Thane Passport Office, Road No 22, Wagle Estate, Thane west,",
      addressLocality: "Thane",
      postalCode: "400604",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/omnamoapp/",
      "https://x.com/My_OmNamo",
      "https://www.instagram.com/myomnamo_official/",
      "https://www.youtube.com/@myomnamo-beliefredefined9691",
      "https://www.linkedin.com/company/my-om-namo/",
    ],
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "What services does My OmNamo offer?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Pandit Booking, Daily Pandit Booking, E-Store, Darshan Booking, Puja at Temple, Horoscope.",
        },
      },
      {
        "@type": "Question",
        name: "Can I schedule a temple visit through My OmNamo?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, you can easily book temple visits online through our platform at your convenience.",
        },
      },
      {
        "@type": "Question",
        name: "Can I book personalized consultations with spiritual mentors?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, you can book sessions with experienced spiritual mentors through our platform.",
        },
      },
    ],
  };

  return (
    <div>


      <audio ref={audioRef} src={audioFile} />

      <Helmet>
        <title>
          {selectedLanguageID === 3 ? "संपूर्ण आध्यात्मिक आणि ऑनलाइन पूजा सेवा बुक करा | Myomnamo" : "Book Complete Spiritual & Online Puja Services | Myomnamo"}
        </title>
        <meta
          name="description"
          content={selectedLanguageID === 3 ? "प्रामाणिक ऑनलाइन पूजा सेवा शोधत आहात का? पंडित, पूजा, जन्मकुंडली आणि मंदिर भेटी ऑनलाइन बुक करा. आमच्या विश्वसनीय ई-स्टोअरमधून पूजा समाग्री आणि आध्यात्मिक वस्तू खरेदी करा." : "Book authentic online pujas, pandits, temple darshan & spiritual guidance online with Myomnamo. Explore daily rituals, astrology insights & devotional products"}
        />
        <link rel="canonical" href="https://www.myomnamo.com/" />

        <meta
          property="og:title"
          content="Book Complete Spiritual & Online Puja Services | Myomnamo"
        />
        <meta
          property="og:description"
          content="Book authentic online pujas, pandits, temple darshan & spiritual guidance online with Myomnamo. Explore daily rituals, astrology insights & devotional products"
        />
        <meta
          property="og:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />
        <meta property="og:url" content="https://www.myomnamo.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:locale" content="en_IN" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Book Complete Spiritual & Online Puja Services | Myomnamo"
        />
        <meta
          name="twitter:description"
          content="Book authentic online pujas, pandits, temple darshan & spiritual guidance online with Myomnamo. Explore daily rituals, astrology insights & devotional products"
        />
        <meta
          name="twitter:image"
          content="https://www.myomnamo.com/assets/images/new/logo.png"
        />


        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(webpageSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>

      {/* <Navbar /> */}
      <MainSlider />
      {/* <CustomChatWidget /> */}
      <WhatsAppChatbotButton />
      {/* <Newsletter /> */}
      {/* <LazySection><AboutUS /></LazySection> */}
      <LazySection><BestServices /></LazySection>
      {/* <LazySection><WhyChooseUs /></LazySection> */}
      <LazySection><DownloadApp languageID={selectedLanguageID} /></LazySection>
      <LazySection><ReferAndEarn moduleName="Home" /></LazySection>
      <LazySection><Support /></LazySection>
      <LazySection><TestimonialsSection /></LazySection>
      <LazySection><FAQSection pageSizeFromHome={10} /></LazySection>
      <LazySection><BlogCarousel /></LazySection>
      {showModal && (
        <LocationModal
          show={showModal}
          onHide={() => setShowModal(false)}
          onSelectCity={handleSelectCity}
        />
      )}
      {
        showLoginModal && (
          <LoginPopUp
            show={showLoginModal}
            onHide={() => setShowLoginModal(false)}
            setOnGetOTP={setOnGetOTP}
          />
        )
      }
    </div>
  );
};

export default Home;
